import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "message"];
  static values = {
    url: String,
    attribute: String,
    minInputLength: Number
  };

  connect() {
    this.element[this.identifier] = this

    this.timeout = null;
    this.debounceTime = 500;
    this.minInputLengthValue = this.minInputLengthValue || 3;

    this.inputTarget.addEventListener("input", () => this.debouncedCheckExistence());
  }

  debouncedCheckExistence() {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.checkExistence();
    }, this.debounceTime);
  }

  addError(message) {
    this.element.classList.add("has-warning");
    this.messageTarget.classList.remove("d-none");
    this.messageTarget.textContent = message;
  }

  clearError() {
    this.element.classList.remove("has-warning");
    this.messageTarget.classList.add("d-none");
    this.messageTarget.textContent = "";
  }

  checkExistence() {
    const inputValue = this.inputTarget.value;
    const attribute = this.attributeValue;
    const url = `${this.urlValue}?${attribute}=${encodeURIComponent(inputValue)}`;

    if (inputValue.length < this.minInputLengthValue) {
      this.clearError();
      return;
    }

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.exists) {
          this.addError(data.message);
        } else {
          this.clearError();
        }
      })
      .catch((error) => {
        console.error("Error checking existence:", error);
      });
  }
}
